// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .cdk-overlay-pane {
  max-width: 92vw !important;
}
::ng-deep .cdk-overlay-pane .mat-mdc-dialog-container {
  border-radius: 16px !important;
  overflow: hidden !important;
  padding: 0 !important;
}
::ng-deep .cdk-overlay-pane .mdc-dialog__container {
  border-radius: 16px !important;
  overflow: hidden !important;
}
::ng-deep .cdk-overlay-pane .mdc-dialog__surface {
  border-radius: 16px !important;
  overflow: hidden !important;
  padding: 0 !important;
}

.attachment-dialog-container {
  display: flex;
  flex-direction: column;
  min-width: 560px;
  max-width: 860px;
  background: #ffffff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
}
@media (max-width: 720px) {
  .attachment-dialog-container {
    min-width: unset;
    width: 100%;
  }
}

.attachment-dialog-header {
  cursor: move;
}
.attachment-dialog-header .attachment-dialog-header-left {
  position: relative;
  z-index: 1;
  min-width: 0;
}
.attachment-dialog-header .header-close-btn {
  width: 30px !important;
  height: 30px !important;
  line-height: 30px !important;
  min-width: unset !important;
  flex-shrink: 0;
  color: rgba(255, 255, 255, 0.75);
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px !important;
  transition: background 0.15s, color 0.15s;
  padding: 0 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  position: relative;
  z-index: 1;
}
.attachment-dialog-header .header-close-btn ::ng-deep .mat-mdc-button-touch-target {
  width: 30px !important;
  height: 30px !important;
}
.attachment-dialog-header .header-close-btn mat-icon {
  font-size: 17px;
  width: 17px;
  height: 17px;
  line-height: 17px;
}
.attachment-dialog-header .header-close-btn:hover {
  background: rgba(255, 255, 255, 0.22);
  color: #fff;
}

.attachment-dialog-body {
  padding: 24px 24px 8px;
  background: #ffffff;
}

.attachment-dialog-content {
  display: flex !important;
  flex-direction: column !important;
  gap: 14px !important;
  padding: 0 !important;
  max-height: min(72vh, 780px) !important;
}

.help-row {
  margin-bottom: 4px;
}

.help-hint {
  color: #475569;
  display: flex;
  align-items: center;
}

.help-btn mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: var(--color-primary);
}

.upload-card-container {
  padding: 8px 0;
}

.upload-card {
  padding: 16px 20px;
  border-radius: 12px;
  border: 2px dashed rgba(15, 23, 42, 0.15);
  background: rgba(15, 23, 42, 0.02);
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  min-width: 120px;
}
.upload-card:hover {
  border-color: var(--color-primary-light);
  transform: translateY(-3px);
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.1);
}
.upload-card:hover .card-icon {
  transform: scale(1.08);
}
.upload-card:hover .card-label {
  color: var(--color-primary-light);
}
.upload-card .card-icon {
  font-size: 44px;
  width: 44px;
  height: 44px;
  margin-bottom: 10px;
  transition: transform 0.25s ease;
}
.upload-card .card-label {
  font-size: 14px;
  font-weight: 600;
  color: rgba(15, 23, 42, 0.7);
  transition: color 0.25s ease;
}

.image-card .card-icon {
  color: #ac44cf;
}

.video-card .card-icon {
  color: #396cd3;
}

.audio-card .card-icon {
  color: #d3396d;
}

.document-card .card-icon {
  color: #5f66cd;
}

.preview-container {
  background: #f8fafc;
  border-radius: 12px;
  border: 1px solid rgba(15, 23, 42, 0.06);
  margin-top: 6px;
  position: relative;
  overflow: hidden;
}

.preview-overlay {
  position: absolute;
  top: 8px;
  right: 8px;
  background: rgba(15, 23, 42, 0.62);
  color: #fff;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  z-index: 1;
}

.preview-image {
  max-height: 220px;
  border-radius: 8px;
}

.preview-video {
  max-height: 260px;
  width: 100%;
  max-width: 500px;
  border-radius: 8px;
}

.preview-file-icon {
  font-size: 64px;
  height: 64px;
  width: 64px;
  opacity: 0.25;
}

.caption-field {
  margin-top: 2px;
}

.status-footer {
  margin-top: 4px;
}

.selected-count {
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
  color: #1e293b;
}
.selected-count mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: #16a34a;
}

.attachment-dialog-actions {
  display: flex !important;
  justify-content: flex-end !important;
  padding: 16px 24px 20px !important;
  background: #ffffff;
  gap: 10px;
  border-top: 1px solid #e2e8f0;
}
.attachment-dialog-actions .cancel-btn,
.attachment-dialog-actions .upload-btn {
  min-width: 130px;
  height: 40px;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.02em;
  border-radius: 8px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 6px;
  transition: box-shadow 0.2s, transform 0.15s;
}
.attachment-dialog-actions .cancel-btn mat-icon,
.attachment-dialog-actions .upload-btn mat-icon {
  font-size: 17px;
  width: 17px;
  height: 17px;
  line-height: 17px;
}
.attachment-dialog-actions .upload-btn {
  box-shadow: 0 4px 14px rgba(26, 86, 219, 0.3);
}
.attachment-dialog-actions .upload-btn:hover:not([disabled]) {
  box-shadow: 0 6px 20px rgba(26, 86, 219, 0.4);
  transform: translateY(-1px);
}`, "",{"version":3,"sources":["webpack://./src/app/shared-component/attachment-dialog/attachment-dialog.component.scss"],"names":[],"mappings":"AAYA;EACI,0BAAA;AAXJ;AAaI;EACI,8BAAA;EACA,2BAAA;EACA,qBAAA;AAXR;AAcI;EACI,8BAAA;EACA,2BAAA;AAZR;AAeI;EACI,8BAAA;EACA,2BAAA;EACA,qBAAA;AAbR;;AAiBA;EACI,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAhCM;EAiCN,mBA9BK;EA+BL,gBAAA;EACA,2CAAA;AAdJ;AAgBI;EAVJ;IAWQ,gBAAA;IACA,WAAA;EAbN;AACF;;AAgBA;EACI,YAAA;AAbJ;AAeI;EACI,kBAAA;EACA,UAAA;EACA,YAAA;AAbR;AAgBI;EACI,sBAAA;EACA,uBAAA;EACA,4BAAA;EACA,2BAAA;EACA,cAAA;EACA,gCAAA;EACA,oCAAA;EACA,6BAAA;EACA,yCAAA;EACA,qBAAA;EACA,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,kBAAA;EACA,UAAA;AAdR;AAgBQ;EACI,sBAAA;EACA,uBAAA;AAdZ;AAiBQ;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAfZ;AAkBQ;EACI,qCAAA;EACA,WAAA;AAhBZ;;AAqBA;EACI,sBAAA;EACA,mBA1FM;AAwEV;;AAqBA;EACI,wBAAA;EACA,iCAAA;EACA,oBAAA;EACA,qBAAA;EACA,uCAAA;AAlBJ;;AAqBA;EACI,kBAAA;AAlBJ;;AAqBA;EACI,cAAA;EACA,aAAA;EACA,mBAAA;AAlBJ;;AAqBA;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;AAlBJ;;AAqBA;EACI,cAAA;AAlBJ;;AAqBA;EACI,kBAAA;EACA,mBAAA;EACA,yCAAA;EACA,kCAAA;EACA,eAAA;EACA,kDAAA;EACA,gBAAA;AAlBJ;AAoBI;EACI,wCAAA;EACA,2BAAA;EACA,yCAAA;AAlBR;AAoBQ;EACI,sBAAA;AAlBZ;AAqBQ;EACI,iCAAA;AAnBZ;AAuBI;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gCAAA;AArBR;AAwBI;EACI,eAAA;EACA,gBAAA;EACA,4BAAA;EACA,4BAAA;AAtBR;;AA0BA;EACI,cAAA;AAvBJ;;AA0BA;EACI,cAAA;AAvBJ;;AA0BA;EACI,cAAA;AAvBJ;;AA0BA;EACI,cAAA;AAvBJ;;AA0BA;EACI,mBAAA;EACA,mBAAA;EACA,wCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AAvBJ;;AA0BA;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,kCAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,UAAA;AAvBJ;;AA0BA;EACI,iBAAA;EACA,kBAAA;AAvBJ;;AA0BA;EACI,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AAvBJ;;AA0BA;EACI,eAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;AAvBJ;;AA0BA;EACI,eAAA;AAvBJ;;AA0BA;EACI,eAAA;AAvBJ;;AA0BA;EACI,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,cArOG;AA8MP;AAyBI;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAvBR;;AA2BA;EACI,wBAAA;EACA,oCAAA;EACA,kCAAA;EACA,mBArPM;EAsPN,SAAA;EACA,6BAAA;AAxBJ;AA0BI;;EAEI,gBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,6BAAA;EACA,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,QAAA;EACA,4CAAA;AAxBR;AA0BQ;;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAvBZ;AA2BI;EACI,6CAAA;AAzBR;AA2BQ;EACI,6CAAA;EACA,2BAAA;AAzBZ","sourcesContent":["// ==========================================================================\n// Component: Attachment-dialog.component\n// ==========================================================================\n\n$primary: var(--color-primary);\n$primary-light: var(--color-primary-tint);\n$surface: #ffffff;\n$border: #e2e8f0;\n$text: #1e293b;\n$radius: 16px;\n$radius-sm: 8px;\n\n::ng-deep .cdk-overlay-pane {\n    max-width: 92vw !important;\n\n    .mat-mdc-dialog-container {\n        border-radius: $radius !important;\n        overflow: hidden !important;\n        padding: 0 !important;\n    }\n\n    .mdc-dialog__container {\n        border-radius: $radius !important;\n        overflow: hidden !important;\n    }\n\n    .mdc-dialog__surface {\n        border-radius: $radius !important;\n        overflow: hidden !important;\n        padding: 0 !important;\n    }\n}\n\n.attachment-dialog-container {\n    display: flex;\n    flex-direction: column;\n    min-width: 560px;\n    max-width: 860px;\n    background: $surface;\n    border-radius: $radius;\n    overflow: hidden;\n    box-shadow: 0 20px 60px rgba(0, 0, 0, .15);\n\n    @media (max-width: 720px) {\n        min-width: unset;\n        width: 100%;\n    }\n}\n\n.attachment-dialog-header {\n    cursor: move;\n\n    .attachment-dialog-header-left {\n        position: relative;\n        z-index: 1;\n        min-width: 0;\n    }\n\n    .header-close-btn {\n        width: 30px !important;\n        height: 30px !important;\n        line-height: 30px !important;\n        min-width: unset !important;\n        flex-shrink: 0;\n        color: rgba(255, 255, 255, 0.75);\n        background: rgba(255, 255, 255, 0.1);\n        border-radius: 8px !important;\n        transition: background .15s, color .15s;\n        padding: 0 !important;\n        display: flex !important;\n        align-items: center !important;\n        justify-content: center !important;\n        position: relative;\n        z-index: 1;\n\n        ::ng-deep .mat-mdc-button-touch-target {\n            width: 30px !important;\n            height: 30px !important;\n        }\n\n        mat-icon {\n            font-size: 17px;\n            width: 17px;\n            height: 17px;\n            line-height: 17px;\n        }\n\n        &:hover {\n            background: rgba(255, 255, 255, 0.22);\n            color: #fff;\n        }\n    }\n}\n\n.attachment-dialog-body {\n    padding: 24px 24px 8px;\n    background: $surface;\n}\n\n.attachment-dialog-content {\n    display: flex !important;\n    flex-direction: column !important;\n    gap: 14px !important;\n    padding: 0 !important;\n    max-height: min(72vh, 780px) !important;\n}\n\n.help-row {\n    margin-bottom: 4px;\n}\n\n.help-hint {\n    color: #475569;\n    display: flex;\n    align-items: center;\n}\n\n.help-btn mat-icon {\n    font-size: 20px;\n    width: 20px;\n    height: 20px;\n    color: var(--color-primary);\n}\n\n.upload-card-container {\n    padding: 8px 0;\n}\n\n.upload-card {\n    padding: 16px 20px;\n    border-radius: 12px;\n    border: 2px dashed rgba(15, 23, 42, 0.15);\n    background: rgba(15, 23, 42, 0.02);\n    cursor: pointer;\n    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n    min-width: 120px;\n\n    &:hover {\n        border-color: var(--color-primary-light);\n        transform: translateY(-3px);\n        box-shadow: 0 8px 18px rgba(0, 0, 0, 0.1);\n\n        .card-icon {\n            transform: scale(1.08);\n        }\n\n        .card-label {\n            color: var(--color-primary-light);\n        }\n    }\n\n    .card-icon {\n        font-size: 44px;\n        width: 44px;\n        height: 44px;\n        margin-bottom: 10px;\n        transition: transform 0.25s ease;\n    }\n\n    .card-label {\n        font-size: 14px;\n        font-weight: 600;\n        color: rgba(15, 23, 42, 0.7);\n        transition: color 0.25s ease;\n    }\n}\n\n.image-card .card-icon {\n    color: #ac44cf;\n}\n\n.video-card .card-icon {\n    color: #396cd3;\n}\n\n.audio-card .card-icon {\n    color: #d3396d;\n}\n\n.document-card .card-icon {\n    color: #5f66cd;\n}\n\n.preview-container {\n    background: #f8fafc;\n    border-radius: 12px;\n    border: 1px solid rgba(15, 23, 42, 0.06);\n    margin-top: 6px;\n    position: relative;\n    overflow: hidden;\n}\n\n.preview-overlay {\n    position: absolute;\n    top: 8px;\n    right: 8px;\n    background: rgba(15, 23, 42, 0.62);\n    color: #fff;\n    padding: 4px 8px;\n    border-radius: 4px;\n    font-size: 12px;\n    z-index: 1;\n}\n\n.preview-image {\n    max-height: 220px;\n    border-radius: 8px;\n}\n\n.preview-video {\n    max-height: 260px;\n    width: 100%;\n    max-width: 500px;\n    border-radius: 8px;\n}\n\n.preview-file-icon {\n    font-size: 64px;\n    height: 64px;\n    width: 64px;\n    opacity: 0.25;\n}\n\n.caption-field {\n    margin-top: 2px;\n}\n\n.status-footer {\n    margin-top: 4px;\n}\n\n.selected-count {\n    font-weight: 500;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-bottom: 10px;\n    color: $text;\n\n    mat-icon {\n        font-size: 18px;\n        width: 18px;\n        height: 18px;\n        color: #16a34a;\n    }\n}\n\n.attachment-dialog-actions {\n    display: flex !important;\n    justify-content: flex-end !important;\n    padding: 16px 24px 20px !important;\n    background: $surface;\n    gap: 10px;\n    border-top: 1px solid $border;\n\n    .cancel-btn,\n    .upload-btn {\n        min-width: 130px;\n        height: 40px;\n        font-size: 13px;\n        font-weight: 600;\n        letter-spacing: .02em;\n        border-radius: $radius-sm !important;\n        display: flex !important;\n        align-items: center !important;\n        justify-content: center !important;\n        gap: 6px;\n        transition: box-shadow .2s, transform .15s;\n\n        mat-icon {\n            font-size: 17px;\n            width: 17px;\n            height: 17px;\n            line-height: 17px;\n        }\n    }\n\n    .upload-btn {\n        box-shadow: 0 4px 14px rgba(26, 86, 219, .3);\n\n        &:hover:not([disabled]) {\n            box-shadow: 0 6px 20px rgba(26, 86, 219, .4);\n            transform: translateY(-1px);\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
